import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import { Download, QrCode, Store } from 'lucide-react';
import { laverieInfo } from '../data/mock';

const QRCodeSection = () => {
  const siteUrl = "https://bayonne-laverie.com";

  const downloadQRCode = () => {
    const canvas = document.getElementById('qr-code-canvas');
    if (canvas) {
      const pngUrl = canvas
        .toDataURL("image/png")
        .replace("image/png", "image/octet-stream");
      
      const downloadLink = document.createElement("a");
      downloadLink.href = pngUrl;
      downloadLink.download = "QRCode-Lavoir-des-Remparts.png";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  };

  const downloadQRCodeHighRes = () => {
    // Create a high-res canvas for printing
    const canvas = document.createElement('canvas');
    const size = 1024; // High resolution for print
    canvas.width = size;
    canvas.height = size;
    const ctx = canvas.getContext('2d');
    
    // White background
    ctx.fillStyle = '#FFFFFF';
    ctx.fillRect(0, 0, size, size);
    
    // Disable image smoothing for crisp QR code
    ctx.imageSmoothingEnabled = false;
    
    // Get the QR canvas and draw it scaled up
    const qrCanvas = document.getElementById('qr-code-canvas');
    if (qrCanvas) {
      ctx.drawImage(qrCanvas, 0, 0, size, size);
      
      const pngUrl = canvas
        .toDataURL("image/png")
        .replace("image/png", "image/octet-stream");
      
      const downloadLink = document.createElement("a");
      downloadLink.href = pngUrl;
      downloadLink.download = "QRCode-Lavoir-des-Remparts-HD.png";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  };

  return (
    <section id="qrcode" className="py-20 bg-gradient-to-b from-zinc-900 to-black">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        {/* Section Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-[#9B1B30]/20 text-[#9B1B30] px-4 py-2 rounded-full text-sm font-semibold mb-4">
            <Store size={16} />
            <span>Pour votre vitrine</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            QR Code de la Laverie
          </h2>
          <p className="text-white/70 max-w-2xl mx-auto text-base md:text-lg">
            Téléchargez ce QR code et affichez-le sur votre vitrine. 
            Vos clients pourront scanner pour accéder directement au site.
          </p>
        </div>

        {/* QR Code Display */}
        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-2xl max-w-md mx-auto" data-testid="qr-code-container">
          {/* Header with branding */}
          <div className="text-center mb-6">
            <div className="w-16 h-16 bg-gradient-to-br from-[#9B1B30] to-[#7A1526] rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-lg">
              <span className="text-white font-black text-2xl">LR</span>
            </div>
            <h3 className="text-xl font-bold text-gray-900">{laverieInfo.name}</h3>
            <p className="text-[#9B1B30] font-semibold text-sm">LAVERIE 3.0 • BAYONNE</p>
          </div>

          {/* QR Code */}
          <div className="flex justify-center mb-6">
            <div className="p-4 bg-white border-4 border-[#9B1B30] rounded-2xl shadow-inner">
              <QRCodeCanvas
                id="qr-code-canvas"
                value={siteUrl}
                size={200}
                level="H"
                includeMargin={true}
                bgColor="#FFFFFF"
                fgColor="#000000"
                data-testid="qr-code-canvas"
              />
            </div>
          </div>

          {/* URL display */}
          <div className="text-center mb-6">
            <p className="text-gray-500 text-sm mb-1">Scannez pour visiter</p>
            <p className="text-[#9B1B30] font-mono text-xs break-all px-4">
              {siteUrl}
            </p>
          </div>

          {/* Download buttons */}
          <div className="space-y-3">
            <button
              onClick={downloadQRCode}
              className="w-full flex items-center justify-center gap-2 bg-[#9B1B30] text-white px-6 py-4 rounded-xl font-semibold hover:bg-[#B91C3B] transition-all shadow-lg hover:shadow-xl hover:scale-[1.02]"
              data-testid="download-qr-button"
            >
              <Download size={20} />
              Télécharger le QR Code
            </button>
            <button
              onClick={downloadQRCodeHighRes}
              className="w-full flex items-center justify-center gap-2 bg-black text-white px-6 py-4 rounded-xl font-semibold hover:bg-gray-800 transition-all"
              data-testid="download-qr-hd-button"
            >
              <QrCode size={20} />
              Version HD pour impression
            </button>
          </div>
        </div>

        {/* Tips */}
        <div className="mt-10 text-center">
          <p className="text-white/50 text-sm">
            💡 <span className="text-white/70">Conseil :</span> Utilisez la version HD pour une impression de qualité sur votre vitrine
          </p>
        </div>
      </div>
    </section>
  );
};

export default QRCodeSection;
